function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  id: "Icon_awesome-file-word",
  "data-name": "Icon awesome-file-word",
  d: "M13.25,7.31V2H5.44a.94.94,0,0,0-.94.93h0V21.06a.94.94,0,0,0,.93.94H18.56a.94.94,0,0,0,.94-.93h0V8.25H14.19A.94.94,0,0,1,13.25,7.31ZM15.48,12h.93a.47.47,0,0,1,.47.47.34.34,0,0,1,0,.1l-1.49,6.57a.45.45,0,0,1-.45.36H13.44a.47.47,0,0,1-.45-.36,33.26,33.26,0,0,1-1-4.31h0a30.5,30.5,0,0,1-1,4.31.47.47,0,0,1-.45.36H9.07a.47.47,0,0,1-.46-.37L7.14,12.57A.47.47,0,0,1,7.49,12H8.55a.46.46,0,0,1,.46.38,47.32,47.32,0,0,1,.82,4.77c.07-.39.29-1.27,1.15-4.79a.45.45,0,0,1,.46-.35h1.13a.45.45,0,0,1,.46.35c.94,3.93,1.13,4.85,1.16,5.06,0-.44-.1-.7.84-5.05A.46.46,0,0,1,15.48,12Zm4-5.24V7h-5V2h.24a.94.94,0,0,1,.66.27L19.23,6.1a1,1,0,0,1,.27.66Z"
});

var SvgIconDocx = function SvgIconDocx(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_35",
    "data-name": "Layer 35",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconDocx, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-docx.c859ee77.svg";
export { ForwardRef as ReactComponent };